import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { scan } from 'react-scan';
import './i18n';
import App from './app/app';
import { ReduxWrapper } from '../../../libs/components/src';

// Initialize React Scan for development
if (typeof window !== 'undefined') {
  scan({
    enabled: true,
    log: true, // logs render info to console
  });
}
// const rootEl = document.getElementById('root');
// ReactDOM.render(
//   <BrowserRouter>
//     <ReduxWrapper>
//       <App />
//     </ReduxWrapper>
//   </BrowserRouter>,
//   rootEl
// );
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ReduxWrapper>
      <App />
    </ReduxWrapper>
  </BrowserRouter>
);
